import { TrendingUp, TrendingDown } from "lucide-react";
import { Sparkline } from "./charts/Sparkline";

export interface KpiCardProps {
  label: string;
  value: string;
  delta: string;
  dir: "up" | "down";
  meta: string;
  spark: number[];
  accent?: "coral";
  onClick?: () => void;
}

export function KpiCard({ label, value, delta, dir, meta, spark, accent, onClick }: KpiCardProps) {
  const color = accent === "coral" ? "var(--coral)" : "var(--primary)";
  const valueStyle = accent === "coral" ? { color: "var(--coral)" } : undefined;

  const inner = (
    <>
      <div className="text-xs text-ink-2 uppercase tracking-wide">{label}</div>
      <div
        className="font-display font-bold text-2xl text-ink"
        data-testid="kpi-value"
        style={valueStyle}
      >
        {value}
      </div>
      <Sparkline values={spark} color={color} />
      <div className="flex items-center justify-between text-[11px] text-muted gap-2">
        <span
          className={`inline-flex items-center gap-1 ${
            dir === "up" ? "text-success" : "text-coral"
          }`}
        >
          {dir === "up" ? (
            <TrendingUp className="size-3" />
          ) : (
            <TrendingDown className="size-3" />
          )}
          {delta}
        </span>
        <span className="truncate">{meta}</span>
      </div>
    </>
  );

  const className = "rounded-md border border-line bg-panel p-4 flex flex-col gap-2 text-left w-full";
  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={`${className} cursor-pointer hover:border-primary/50 transition-colors`}>
        {inner}
      </button>
    );
  }
  return <div className={className}>{inner}</div>;
}
